/**
 * The app version, baked into the bundle at build time (see vite.config.ts).
 * Format: {major}.{minor}.{build}, e.g. "0.3.1006".
 */
export const APP_VERSION: string = __APP_VERSION__;

/**
 * How the version reads in the UI. Production shows the bare number; every
 * other environment appends " - {env}" so a tester knows at a glance where
 * they are (a bare version == prod). Environment comes from the runtime
 * config.json (getRuntimeConfig().environment).
 */
export function formatAppVersion(environment: string): string {
  const env = environment.trim().toLowerCase();
  const isProd = env === 'prod' || env === 'production';
  return isProd ? APP_VERSION : `${APP_VERSION} - ${environment}`;
}
